import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useMutation, useQueryClient } from "react-query";

import { Modal, Button, Input } from "rsuite";
import apiClient from "../../libraries/ApiClient";
const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function HourglassHalfRegular({ rowId, code, time, caseCode, hospital }) {
  const queryClint = useQueryClient();
  const [token, setToken] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
  }, []);

  const sendCheckData = async ({ rowId, code, token }) => {
    const data = {
      Data: {
        RowId: rowId,
        Code: code,
        Value: 2,
        Content: "",
      },
    };


    const res = await apiClient.postAes(
      "api/referral/SetPatientStatus/Security",
      data
    );

    return res;
  };

  const {
    data: checkData,
    mutate,
    isLoading,
  } = useMutation(sendCheckData, {
    onSuccess() {
      alert("更新成功");
      setOpen(false);
      //queryClint.invalidateQueries("getListData");
      window.location.reload(true);
    },
  });
  // console.log(checkData);
  return (
    <>
      <span style={{ padding: "5px" }} onClick={handleOpen}>
        <Container
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="2.5"
            stroke="#057AFF"
          />
          <path
            d="M8.66649 7C8.29784 7 8 7.30723 8 7.6875C8 8.06777 8.29784 8.375 8.66649 8.375V8.61133C8.66649 9.52227 9.01848 10.3967 9.64332 11.0412L11.0555 12.5L9.64332 13.9588C9.01848 14.6033 8.66649 15.4777 8.66649 16.3887V16.625C8.29784 16.625 8 16.9322 8 17.3125C8 17.6928 8.29784 18 8.66649 18H9.33299H14.6649H15.3314C15.7001 18 15.9979 17.6928 15.9979 17.3125C15.9979 16.9322 15.7001 16.625 15.3314 16.625V16.3887C15.3314 15.4777 14.9794 14.6033 14.3546 13.9588L12.9425 12.5L14.3567 11.0412C14.9815 10.3967 15.3335 9.52227 15.3335 8.61133V8.375C15.7022 8.375 16 8.06777 16 7.6875C16 7.30723 15.7022 7 15.3335 7H14.6649H9.33299H8.66649ZM9.99948 8.61133V8.375H13.9984V8.61133C13.9984 9.01953 13.8818 9.41484 13.6652 9.75H10.3327C10.1182 9.41484 9.99948 9.01953 9.99948 8.61133ZM10.3327 15.25C10.4056 15.1361 10.491 15.0287 10.5847 14.9299L11.999 13.4732L13.4132 14.932C13.509 15.0309 13.5923 15.1383 13.6673 15.2521H10.3327V15.25Z"
            fill="#057AFF"
          />
        </Container>
      </span>
      <Modal
        open={open}
        onClose={handleClose}
        backdrop="static"
        overflow={true}
      >
        <Modal.Header>
          <Modal.Title>確認轉診</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "100px",
            display: "flex",
            flexDirection: "column",
            // height: "100vh",
          }}
        >
          <div style={{ fontSize: "14px", lineHeight: "28px" }}>
            {/* 本院目前可接收「{time}
            {hospital}提報取栓轉診(收案編號{caseCode}
            )」病人進行取栓治療。請跟家屬解釋：到院需再做MRI或CTA評估是否大血管阻塞，才會進行取栓手術。取栓可能的風險有麻醉風險、CKD患者腎功能惡化、心肺疾病者拔管困難等（嚴重者需要氣切）。取栓手術可增加神經功能恢復機會，但不保證病人一定能復原，復原不理想者仍可能癱瘓臥床。若家屬同意，可轉院進行取栓評估，務必請主要決策家屬陪同，並請貴院急診協助以下前置作業：
            <div style={{ padding: "16px" }}>
              <p>1. 完成院際轉診交班</p>
              <p>2. 先換病人服</p>
              <p>3. 左手打20號IC</p>
              <p>4. 放置尿管</p>
            </div> */}
          </div>
          <div
            style={{ fontSize: "14px", display: "flex", alignItems: "center" }}
          >
            經院確認:
            <span style={{ fontSize: "28px", color: "#159895" }}>
              「請稍後,尚待確認」
            </span>
          </div>
          <div style={{ fontSize: "14px", padding: "16px" }}>
            *3分鐘後若仍未確認，會再次提醒您!
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              mutate({ rowId, code, token });
            }}
            appearance="primary"
            disabled={isLoading}
          >
            {isLoading ? "資料傳送中" : "確認"}
          </Button>
          <Button onClick={handleClose}>取消返回</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default HourglassHalfRegular;
